import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export default function NewQuipReleaseNotification() {
  return (
    <Box
      sx={{
        border: '2px solid #dacd3e',
        backgroundColor: '#ffffd9',
        padding: '1em',
      }}
    >
      <Typography component="div" sx={{ fontWeight: 'bold', marginBottom: '0.5em' }}>
        <FormattedMessage id="newQuipReleaseNotificationTitle" />
      </Typography>
      <Typography component="div">
        <FormattedMessage
          id="newQuipReleaseNotification"
          values={{
            webshop: (
              <Link href="https://shop.quip.eu" target="_blank" rel="noopener noreferrer" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                QuIP Shop
              </Link>
            ),
          }}
        />
      </Typography>
    </Box>
  );
}
